import { Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Navigate } from "react-router";
import { ProfileContactViewContainer } from "../components/profile-contact-view.container";
import { ProfileContactEditContainer } from "../components/profile-contact-edit.container";

export const ProfileContact: React.FC = () => {
  return (
    <div style={{width: "100%"}}>
      <Helmet>
        <title>Profile - Contact</title>
      </Helmet>
      <Routes>
        <Route index element={<Navigate to="view" replace />} />
        <Route path="view/*" element={<ProfileContactViewContainer />} />
        <Route path="edit/*" element={<ProfileContactEditContainer />} />
      </Routes>
    </div>
  );
};
